import { Component, OnDestroy, OnInit } from '@angular/core';
import { AnalyticsService, AuthorizationService, LoggingService, TimePeriod } from 'app/shared';
import { BaseDetailsLogic } from 'app/analytics/BaseDetailsLogic';
import { GlobalSearchTermsConfig } from 'app/shared/model/charts/user-analytic-configurations.model';
import { TooltipCoordinatorService } from 'app/analytics/services/tooltip-coordinator.service';

@Component({
  selector: 'app-global-search-term-details',
  templateUrl: './global-search-term-details.component.html',
  standalone: false,
})
export class GlobalSearchTermDetailsComponent
  extends BaseDetailsLogic<GlobalSearchTermsConfig>
  implements OnInit, OnDestroy
{

  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(analyticsService, authService, loggingService, GlobalSearchTermsConfig, tooltipCoordinator);
  }

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  get selectedMinUsed(): number {
    return this.config?.minUsed || 1;
  }

  set selectedMinUsed(value: number) {
    this.config.minUsed = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
    }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      minUsed:
        "Set the minimum number of times a search term must be used to appear in the list. For example, if you enter 5, you will only see search terms that were used at least 5 times. This helps you focus on the most popular search terms people are using.",
    };
  }
}